import { Formula, Vehicle } from '@otw/models'
import { calculatePrice } from '@/hooks/graybook/useFormula'
import { getDealQuality } from 'hooks/graybook/useCalculateDeal'
import { matchFormula } from 'hooks/graybook/matchFormula'

export type VehicleDealMetrics = {
  grayBookRetailPrice: number | null
  ltv: number | null
  dealQuality: Vehicle['dealQuality']
  matchedFormulaId: string | null
}

export const calculateDealForVehicle = (
  vehicle: Vehicle | null | undefined,
  formulas: Formula[] | undefined,
  isOwner: boolean,
): VehicleDealMetrics | null => {
  if (!vehicle || !formulas) {
    return null
  }

  const { make, model, type, size, miles, year, fuel, optic_list_price, seller_asking_price } = vehicle

  if (!make || !model || !type || !size || !miles || !year || !fuel) {
    return null
  }

  const matchedFormula = matchFormula(formulas, vehicle)
  if (!matchedFormula?.rules?.length) {
    return null
  }

  const result = calculatePrice({
    input: {
      year: typeof year === 'string' ? Number(year) : year,
      mileage: Number(String(miles).replace(/,/g, '')),
    },
    formula: matchedFormula,
    rules: matchedFormula.rules,
  })

  const grayBookRetailPrice = result.price ?? null
  if (!grayBookRetailPrice) {
    return null
  }

  let ltv: number | null = null
  if (optic_list_price) {
    const listPrice = parseFloat(String(optic_list_price))
    if (!isNaN(listPrice) && listPrice > 0) {
      ltv = (listPrice / grayBookRetailPrice) * 100
    }
  }

  let dealQuality: Vehicle['dealQuality'] = null
  if (seller_asking_price) {
    const askingPrice = parseFloat(String(seller_asking_price))
    if (!isNaN(askingPrice)) {
      const wholesalePrice = grayBookRetailPrice * (1 - (matchedFormula.wholesaleDiscount || 0) / 100)
      dealQuality = getDealQuality(askingPrice, wholesalePrice, isOwner)
    }
  }

  return {
    grayBookRetailPrice,
    ltv,
    dealQuality,
    matchedFormulaId: matchedFormula.id ?? null,
  }
}
